import httpClient from "@/plugins/axios";

export const getNewsList = async (page, pageSize, tagId = null) => {
    let url = `/v1/news/?page=${page}&page_size=${pageSize}`;
    if (tagId) {
        url += `&tag=${tagId}`;
    }
    const response = await httpClient.get(url);
    return response;
}

export const getNews = async (newsId) => {
    const response = await httpClient.get(`/v1/news/${newsId}/`);
    return response;
}


export const downloadNewsAttachment = async (newsId, attachmentId) => {

    const response = await httpClient.get(
        `/v1/news/${newsId}/attachments/${attachmentId}/`,
        {
            responseType: 'blob',
        }
    )

    return response;
}
